import { c as _c } from "react/compiler-runtime";
import { Alert, Badge, Box, CircleSpinnerInline, EmployeeAvatarType, FeaturedCard } from '@newfront-insurance/core-ui';
import { PolicyStatus } from '@newfront-insurance/coverage-api';
import { useContext, type JSX } from 'react';
import { PolicyDefinitionList } from './policy-definition-list';
import { renderPolicyName, usePolicy } from '../../../../../../../coverage';
import type { SearchResultRouting } from '../../../../../../bff/types';
import { bugsMessage } from '../../../../../utils';
import { SearchContext } from '../../../context';
import { useItemResultRouting } from '../../../hooks/use-item-result-routing';
import { LoadingWrapper } from '../loading-wrapper';
import { ServicingTeam } from '../servicing-team';
interface Props {
  policyUuid: string;
  routing: SearchResultRouting;
}
export function PolicyCardPreview(t0) {
  const $ = _c(36);
  const {
    policyUuid,
    routing
  } = t0;
  let t1;
  if ($[0] !== policyUuid) {
    t1 = {
      policyUuid
    };
    $[0] = policyUuid;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    data: policy,
    error
  } = usePolicy(t1);
  const {
    goToItemResultPage
  } = useItemResultRouting();
  const {
    setIsSearchActive
  } = useContext(SearchContext);
  if (error) {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <Box width={512}><Alert>{bugsMessage("Something went wrong trying to load the policy")}</Alert></Box>;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  if (!policy) {
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <LoadingWrapper><CircleSpinnerInline /></LoadingWrapper>;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  const {
    accountUuid,
    details,
    definition,
    type,
    status,
    accountManagers,
    producers
  } = policy;
  const t2 = `/accounts/${accountUuid}`;
  let t3;
  if ($[4] !== accountUuid) {
    t3 = {
      pathname: `/accounts/[accountUuid]`,
      query: {
        accountUuid
      }
    };
    $[4] = accountUuid;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = {
      absolute: t2,
      relative: t3
    };
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const accountRouting = t4;
  const t5 = definition?.readableName ?? type;
  let t6;
  if ($[9] !== details.displayName || $[10] !== t5) {
    t6 = renderPolicyName(t5, details.displayName);
    $[9] = details.displayName;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== goToItemResultPage || $[13] !== routing || $[14] !== setIsSearchActive) {
    t7 = async e => {
      e.preventDefault();
      setIsSearchActive(false);
      await goToItemResultPage(routing);
    };
    $[12] = goToItemResultPage;
    $[13] = routing;
    $[14] = setIsSearchActive;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== accountRouting || $[17] !== goToItemResultPage) {
    t8 = async e_0 => {
      e_0.preventDefault();
      await goToItemResultPage(accountRouting);
    };
    $[16] = accountRouting;
    $[17] = goToItemResultPage;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== policy || $[20] !== t8) {
    t9 = <PolicyDefinitionList policy={policy} onAccountClick={t8} />;
    $[19] = policy;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== accountManagers || $[23] !== producers) {
    t10 = (accountManagers.length > 0 || producers.length > 0) && <ServicingTeam servicingTeam={[...accountManagers.map(_temp), ...producers.map(_temp2)]} />;
    $[22] = accountManagers;
    $[23] = producers;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10 || $[26] !== t9) {
    t11 = <>{t9}{t10}</>;
    $[25] = t10;
    $[26] = t9;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== status) {
    t12 = status === PolicyStatus.ACTIVE ? <Badge type="success">Active</Badge> : null;
    $[28] = status;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== routing.absolute || $[31] !== t11 || $[32] !== t12 || $[33] !== t6 || $[34] !== t7) {
    t13 = <Box backgroundColor="#fff" borderRadius={6} width={512}><FeaturedCard eyebrow="Policy" title={t6} href={routing.absolute} onClick={t7} content={t11} badge={t12} /></Box>;
    $[30] = routing.absolute;
    $[31] = t11;
    $[32] = t12;
    $[33] = t6;
    $[34] = t7;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  return t13;
}
function _temp2(pd) {
  return {
    ...pd,
    name: pd.fullName,
    legacyId: pd.deprecatedId,
    uuid: pd.deprecatedUuid,
    type: EmployeeAvatarType.Producer
  };
}
function _temp(am) {
  return {
    ...am,
    name: am.fullName,
    legacyId: am.deprecatedId,
    uuid: am.deprecatedUuid,
    type: EmployeeAvatarType.AccountManager
  };
}